import { useState } from 'react';
import initialState from '../context/initialState';

const useInitialState = () => {
  const [state, setState] = useState(initialState);

  const addToFavorites = (payload) => {
    setState({
      ...state,
      favoritos: [...state.favoritos, payload],
    });
  };

  const setIdPedido = (payload) => {
    setState({
      ...state,
      idPedido: payload
    });
  };
  return {
    addToFavorites,
    setIdPedido,
    state,
  };
};

export default useInitialState;
